module.exports = __webpack_public_path__ + "static/media/card-Charlie-mobile-inactive.dcdb8750.svg";